import React from 'react'
import HeaderSection from '../../../../components/common/Header/HeaderSection'
import AddForm from './Viewall'

const Liability = () => {
    return (
        <div>
            <HeaderSection
                title="Payment Voucher"
                breadcrumb={["Dashboard", "Voucher", "Payment List"]}
            />
            <AddForm />
        </div>
    )
}

export default Liability